import { Button, ButtonGroup } from "@aws-amplify/ui-react"
import { useContext } from "react"
import { FaSignOutAlt } from "react-icons/fa"
import { isRouteErrorResponse, useRouteError } from "react-router-dom"
import { UserDataContext } from "../contexts"
import { useSignOutHandler } from "../hooks"
import RefreshUserDataButton from "./RefreshUserDataButton"

interface ErrorBoundaryProps {
  showTitle?: boolean
}
export function ErrorBoundary({ showTitle = true }: ErrorBoundaryProps) {
  const error = useRouteError()
  const { clearUserData } = useContext(UserDataContext)
  const signOutHandler = useSignOutHandler(clearUserData)
  console.error(error)
  return (
    <>
      {showTitle && (
        <div>
          <h1>Strautmann SDS</h1>
        </div>
      )}
      <div>
        Es ist ein Fehler aufgetreten. Sie können versuchen, alle Daten neu zu
        laden, oder sich neu anzumelden.
      </div>

      <ButtonGroup className="!mt-4">
        <RefreshUserDataButton />
        <Button type="button" onClick={signOutHandler}>
          <FaSignOutAlt />
          &nbsp;Abmelden
        </Button>
      </ButtonGroup>

      <div className="mt-20 text-s text-gray-300">
        {isRouteErrorResponse(error) && (
          <>
            <div>{error.status}</div>
            <div>{error.data}</div>
            {error.data?.message && <div>{error.data.message}</div>}
          </>
        )}
        {
          // @ts-ignore
          error?.message && <div>{error.message}</div>
        }
      </div>
    </>
  )
}
